import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useCreateSOP } from "../api/queries";
import { SOPForm } from "../ui/SOPForm";

export function SOPCreatePage() {
  const nav = useNavigate({ from: "/app/sop/new" });
  const createSOP = useCreateSOP();

  return (
    <>
      <Header />
      <Main>
        <div className="space-y-4">
          <div className="flex items-center justify-between gap-4">
            <h1 className="font-semibold text-2xl">ສ້າງ SOP ໃໝ່</h1>

            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => nav({ to: "/app/sop" })}
            >
              <ArrowLeftIcon className="mr-2 h-4 w-4" />
              ກັບ
            </Button>
          </div>

          <div className="rounded-lg border bg-card p-6">
            <SOPForm
              onSubmit={async (values) => {
                await createSOP.mutateAsync(values);
                nav({ to: "/app/sop" });
              }}
              submitting={createSOP.isPending}
            />
          </div>
        </div>
      </Main>
    </>
  );
}
